export const cabecalhos = [
  {
    text: 'Grupo Compra',
    value: 'descricao_grupo',
    style: {
      width: '10%'
    }
  },
  {
    text: 'ID Produto',
    value: 'idproduto',
    style: {
      width: '10%'
    }
  },
  {
    text: 'Descrição Produto',
    value: 'descricao_linha',
    style: {
      width: '20%'
    }
  },
  {
    text: 'data_analise_inicial',
    value: 'valor_data_inicial',
    formatar_valor: true,
    style: {
      width: '15%'
    }
  },
  {
    text: 'data_analise_final',
    value: 'valor_data_final',
    formatar_valor: true,
    style: {
      width: '15%'
    }
  },
  {
    text: 'Diferença',
    value: 'diferenca_em_valor',
    formatar_valor: true,
    style: {
      width: '15%'
    }
  },
  {
    text: 'Diferença%',
    value: 'diferenca_em_porcentagem',
    formatar_valor: true,
    style: {
      width: '15%'
    }
  },
];
